<template>
  <div class="stack-20">
    <h2>Дополнительные услуги</h2>
    <p>
      Здесь находится информация обо всех услугах, которые вы можете подключить дополнительно.
      После ознакомления с условиями вы можете оставить заявку на подключение, воспользовавшись формой внизу страницы.
    </p>
    <div v-for="group in optionsGroups" :key="group.groupName" class="fm-0">
      <h3>{{ group.groupName }}</h3>
      <page-widget v-for="service in group.services" :key="service.name" class="mt-20">
        <template v-slot:heading>{{ service.name }}</template>
        <template v-slot:body>
          <p>{{ service.description }}</p>
          <component :is="service.prices.type" v-if="service.prices" :data="service.prices.data"></component>
          <el-button
            v-if="service.button"
            :title="service.name"
            type="primary"
            class="mt-12"
            size="medium"
            :disabled="!$store.state.user.accInfo.isAdmin"
            @click="requestActivationSingle(service.name)">
            {{ service.button }}
          </el-button>
        </template>
      </page-widget>
    </div>

    <page-widget>
      <template v-slot:heading>Оставьте заявку на подключение дополнительных услуг</template>
      <template v-slot:body>
        <el-input
          v-model="message" type="textarea"
          :autosize="{ minRows: 5, maxRows: 10}" />
        <div class="flex-x-center">
          <el-button
            type="primary"
            class="mt-12"
            size="medium"
            :loading="$mip('requestServiceActivation')"
            :disabled="!$store.state.user.accInfo.isAdmin"
            @click="requestActivation">
            Отправить
          </el-button>
        </div>
      </template>
    </page-widget>
  </div>
</template>

<script>
  import PageWidget from '@/components/PageWidget.vue'
  import PriceTable from './PriceTable.vue'
  import ReportsPrice from './ReportsPrice.vue'

  export default {
    components: {
      PageWidget,
      PriceTable,
      ReportsPrice
    },

    data() {
      return {
        message: '',
        optionsGroups: [
          {
            groupName: 'Отраслевые решения',
            services: [
              {
                name: '1С: Бухгалтерия строительной организации',
                description: '200 руб./пользователь в месяц',
                button: 'Подключить'
              },
              {
                name: '1С: Бухгалтерия КОРП',
                description: '200 руб./пользователь в месяц',
                button: 'Подключить'
              },
              {
                name: 'Другие конфигурации',
                description: 'У нас можно получить доступ и к другим конфигурациям 1С',
                button: 'Оставить заявку'
              }
            ]
          },
          {
            groupName: 'Инструменты',
            services: [
              {
                name: '1С:Отчетность',
                description: 'Сдача регламентированной отчетности во все контролирующие органы ФСН, ПФР, ФСС, Росстат из программ 1С, без переключения в другие программы, выгрузки/загрузки файлов и без повторного заполнения форм.',
                button: 'Подключить',
                prices: {
                  type: 'reports-price',
                  data: {
                    tabs: [
                      {
                        tabName: 'Москва',
                        yl: [
                          {
                            service: 'Подключение на 1 месяц',
                            price: '590 руб.'
                          },
                          {
                            service: 'Подключение на 12 месяцев',
                            price: '5900 руб.'
                          }
                        ],
                        ip: [
                          {
                            service: 'Подключение на 1 месяц',
                            price: '220 руб.'
                          },
                          {
                            service: 'Подключение на 12 месяцев',
                            price: '2 200 руб.'
                          }
                        ]
                      },
                      {
                        tabName: 'Московская область',
                        yl: [
                          {
                            service: 'Подключение на 1 месяц',
                            price: '490 руб.'
                          },
                          {
                            service: 'Подключение на 12 месяцев',
                            price: '4 900 руб.'
                          }
                        ],
                        ip: [
                          {
                            service: 'Подключение на 1 месяц',
                            price: '180 руб.'
                          },
                          {
                            service: 'Подключение на 12 месяцев',
                            price: '1 800 руб.'
                          }
                        ]
                      },
                      {
                        tabName: 'Регионы',
                        yl: [
                          {
                            service: 'Подключение на 1 месяц',
                            price: 'от 390 руб.'
                          },
                          {
                            service: 'Подключение на 12 месяцев',
                            price: 'от 3 900 руб.'
                          }
                        ],
                        ip: [
                          {
                            service: 'Подключение на 1 месяц',
                            price: '150 руб.'
                          },
                          {
                            service: 'Подключение на 12 месяцев',
                            price: '1 500 руб.'
                          }
                        ]
                      }
                    ],
                    discount: 'При подключении группы пользователей предусмотрены скидки до 65%'
                  }
                }
              },
              {
                name: '1С:Контрагент',
                description: 'Быстрая проверка актуальности  и достоверности сведений о контрагентах, автоматическое заполнение реквизитов контрагентов в различных документах ',
                button: 'Подключить',
                prices: {
                  type: 'price-table',
                  data: [
                    {
                      service: 'Подключение на 1 месяц',
                      price: '480 руб.'
                    },
                    {
                      service: 'Подключение на 12 месяцев',
                      price: '4 800 руб.'
                    }
                  ]
                }
              },
              {
                name: '1С-ОФД',
                description: 'Подключение к операторам фискальных данных (ОФД) в соответствии с законом 54-ФЗ, квалифицированная поддержка партнерами 1С при переходе на новый порядок применения контрольно-кассовой техники. От 750 руб.',
                button: 'Подключить',
                prices: {
                  type: 'price-table',
                  data: [
                    {
                      service: 'Подключение на 1 месяц',
                      price: '750 руб. / за 1 ККТ'
                    },
                    {
                      service: 'Подключение на 6 месяцев',
                      price: '1 500 руб. / за 1 ККТ'
                    },
                    {
                      service: 'Подключение на 12 месяцев',
                      price: '3 000 руб. / за 1 ККТ'
                    },
                    {
                      service: 'Подключение на 15 месяцев',
                      price: '3 500 руб. / за 1 ККТ'
                    },
                    {
                      service: 'Подключение на 36 месяцев',
                      price: '6 500 руб. / за 1 ККТ'
                    }
                  ]
                }
              },
              {
                name: '1C-ABBYY Comparator',
                description: 'Сравнение документов в текстовых и графических форматах в различных комбинациях, выявление значимых несоответствий, отчет о различиях. Функционал «1C-ABBYY Comparator» помогает быстро выявлять значимые несоответствия в тексте и предотвратить подписание или публикацию некорректной версии документа.',
                button: 'Подключить',
                prices: {
                  type: 'price-table',
                  data: [
                    {
                      service: '«1C-ABBYY Comparator» лицензия на  3 месяца',
                      price: '2 490 руб.'
                    },
                    {
                      service: '«1C-ABBYY Comparator» лицензия на 6 месяцев',
                      price: '3 590 руб.'
                    },
                    {
                      service: '«1C-ABBYY Comparator»  лицензия на 12 месяцев',
                      price: '5 990 руб.'
                    }
                  ]
                }
              },
              {
                name: '1С-Товары',
                description: 'Прогноз спроса и автоматический заказ товаров. Анализ работы розничного магазина.',
                button: 'Подключить',
                prices: {
                  type: 'price-table',
                  data: [
                    {
                      service: 'Тестовый месяц',
                      price: 'Бесплатно'
                    },
                    {
                      service: '1С-Товары. Автозаказ для магазина',
                      price: '1000 руб/месяц за один магазин'
                    },
                    {
                      service: '1С-Товары. Аналитика продаж для магазина',
                      price: '1000 руб/месяц за один магазин'
                    },
                    {
                      service: '1С-Товары. Комплексный для магазина',
                      price: '1700 руб/месяц за один магазин'
                    },
                    {
                      service: '1С-Товары. Автозаказ 300 товаров',
                      price: '300 руб/месяц за один магазин'
                    }
                  ]
                }
              }

            ]
          },
          {
            groupName: 'Дополнительные опции',
            services: [
              {
                name: '1С-ЭДО',
                button: 'Подключить',
                description: 'Обмен электронными документами с контрагентами, между своими организациями в группе компаний.   Входящие электронные документы бесплатно, стоимость отправки комплекта документов, начиная со 1-го комплекта – 10 руб. за комплект '
              },
              {
                name: 'Информационная система 1С:ИТС',
                button: 'Подключить',
                description: 'Актуальные новости законодательства, практические рекомендации по ведению учета, пошаговые инструкции по работе с программами 1С. Авторами материалов являются разработчики, аудиторы и методисты фирмы «1С» - 16 800 руб ./год.'
              },
              {
                name: '1СПАРК риски',
                button: 'Подключить',
                description: 'Оценка надежности и мониторинг контрагентов в программах 1С для принятия взвешенных решений о сотрудничестве и минимизации налоговых рисков.',
                prices: {
                  type: 'price-table',
                  data: [
                    {
                      service: '1СПАРК Риски',
                      price: '3 000 руб. / год'
                    },
                    {
                      service: '1СПАРК Риски +',
                      price: '22 500 руб. / год'
                    }
                  ]
                }
              },
              {
                name: 'Сервис 1С:Сверка',
                button: 'Подключить',
                description: 'Автоматическая сверка счетов-фактур с контрагентами непосредственно в  программе 1С в любое удобное время – как в процессе ведения учета, так и перед отправкой декларации в ФНС.  Без оплаты '
              },
              {
                name: '1С:ДиректБанк',
                button: 'Подключить',
                description: 'Прямой обмен электронными документами с банком. Позволяет отправлять платежи в банк и получать выписки по расчетным счетам непосредственно из программ «1С», без переключения в систему «Клиент-банк». Без оплаты.'
              },
              {
                name: '1С:Бизнес-сеть.Торговая площадка',
                button: 'Подключить',
                description: 'Торговая площадка в программах «1С:Предприятие» для поставщиков и покупателей (закупщиков). Предназначен для поставщиков и покупателей (закупщиков). С его помощью поставщики могут упростить обработку входящих заказов и получить новых клиентов, а закупщики — найти выгодных поставщиков и сократить время оформления заказа. Торговая площадка в программах «1С:Предприятие» для поставщиков и покупателей (закупщиков). Без оплаты.'
              }
            ]
          }

        ]
      }
    },

    methods: {
      async requestActivation() {
        await this.$http.requestServiceActivation(this.message)
        this.message = ''
        this.$notify({
          title: 'Подключение услуг',
          message: 'Ваша заявка принята. С вами свяжется менеджер',
          type: 'success'
        })
      },
      async requestActivationSingle(item) {
        await this.$http.requestServiceActivation(item)
        this.$notify({
          title: 'Подключение услуг',
          message: 'Ваша заявка принята. С вами свяжется менеджер',
          type: 'success'
        })
      }
    }
  }
</script>